<div fxLayout="column" fxLayoutAlign="center start">
  <div
    *ngFor="let workItem of workItems"
    fxLayout="row"
    fxLayoutAlign="start center"
    class="products-column"
  >
    <mat-icon
      [matTooltip]="getMatTooltip(workItem)"
      matTooltipPosition="left"
      [ngClass]="getWorkItemStatusColor(workItem.status)">boy</mat-icon>
    <div fxFlex class="ellipsis">
      {{ workItem.workList?.name}}
    </div>
  </div>
</div>
